import React from "react";

const ValidationError = ({ value }) => (
  <p data-error="true" className="text-red text-12 mt-1">{value}</p>
);

export default ValidationError;
